<template>
    <div class="calendar-container">
        <div v-show="screenSize > 1 && sidebarVisible" class="sidebar" :class="isDownloading?'sidebar-downloading':''">
            <div class="sidebar-calendar">
                <calendar 
                    v-bind:screenSize="screenSize"
                    v-bind:current="current"
                    v-bind:selectedDay="selectedDay"
                ></calendar>
            </div>
            <div class="sidebar-info">
                <div class="sidebar-info-value">
                    {{$l('main/titleSD')}}<span :class="{red:isSizeBelowLimit}"> {{roundDecimal}}% </span> ({{$l('settings/status/of')}} 2 Gb)
                </div>
                <div class="sidebar-status-value">
                    {{$l('main/status')}}: {{$l('main/'+statusSidebar)}}
                </div>
            </div>
        </div>
        
        <el-collapse-transition >
            <div v-show="screenSize < 2 && sidebarVisible" class="sidebar-top-container">
                <div class="sidebar-top">
                    <div class="sidebar-top-calendar">
                        <calendar 
                            v-bind:small="true" 
                            v-bind:screenSize="screenSize"
                            v-bind:current="current"
                            v-bind:selectedDay="selectedDay"
                        ></calendar>
                    </div>
                    <div class="sidebar-top-info">
                        <div class="sidebar-info-value">
                            {{$l('main/titleSD')}}<span :class="{red:isSizeBelowLimit}"> {{roundDecimal}}% </span> ({{$l('settings/status/of')}} 2 Gb)
                        </div>
                        <div class="sidebar-status-value">
                            {{$l('main/status')}}: {{$l('main/'+statusSidebar)}}
                        </div>
                    </div>
                </div>
            </div>
        </el-collapse-transition>
    </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

//components
import Calendar from './Calendar';

export default {
    props:['screenSize', 'sidebarVisible'],
    computed:{
        ...mapGetters([
            'getSettingsDevice',
            'getSystemStatus',
            'getStatus',
            'getSelectedDay',
            'getMounted',
            'getDownloading'
        ]),
        isDownloading: function(){
            return this.getDownloading.enabled;
        },
        contentClassname: function(){return 'content'+((this.screenSize > 1 && this.sidebarVisible)?' sidebar-visible': '');},
        isSizeBelowLimit: function(){return this.roundDecimal <= parseInt(this.getSettingsDevice.sdfreelimit);},
        roundDecimal:function(){return Math.round((100 - this.getSystemStatus.n140_sd_percent) * 10) / 10;},
        statusMessage: function(){ return (this.getStatus.noiseCode)? "n140:"+this.getStatus.noiseCode:((this.getStatus.weatherCode)? "weather:"+this.getStatus.weatherCode:(this.getStatus.adioCode)?"adio:"+this.getStatus.adioCode:''); },
        sdStatusMessage: function(){return (this.statusMessage) ? false : this.isSizeBelowLimit;},
        hddStatusMessage: function(){ return (this.statusMessage || this.sdStatusMessage) ? false : this.isHddSizeBelowLimit},
        statusSidebar: function(){return this.statusMessage?'error':(this.playButtonClass.ok)?'running':(this.playButtonClass.danger)?'notRunning':(this.playButtonClass.warning)?'running':'notRunning';},
        playButtonClass:function(){
            var isError =  (this.getStatus.weatherError || this.getStatus.noiseError || this.getStatus.adioError);
            return {
                danger:(!this.getStatus.noise && !this.getStatus.weather)|| isError,
                warning:(!this.getStatus.noise || !this.getStatus.weather || !this.getStatus.adio) && !isError, 
                ok:(this.getStatus.noise && this.getStatus.weather || this.getStatus.adio) && !isError

            }
        },
        selectedDayString: function(){
            return this.getSelectedDay.year+'-'+this.getSelectedDay.month+'-'+this.getSelectedDay.day;
        },
        isStatistics: function(){
            return this.$route.path.indexOf('/statistics') > -1;
        }
    },
    components:{
        'calendar':Calendar
    },
    data:function(){
        return{
            current:{
                month:0,
                year:2017,
            },
            
            selectedDay:{
                month:0,
                year:2017,
                day:1
            },
        }
    },
    methods:{
        ...mapActions([
            'getSelectedDayHours',
            'getMeasurementsDays',
            'setSelectedDay',
            'getSelectedDayHours',
            'setSelectedHour',
            'mounted'
        ])
    },
    mounted:function(){
       
        var date = new Date();
        this.current.month = date.getMonth();
        this.current.year = date.getFullYear();
        
        date.setDate(1);

        this.getMeasurementsDays()
            .then((activeDays)=>{
                var activeDaysNames = Object.keys(activeDays)
                if(activeDaysNames.length > 0){
                    activeDaysNames = activeDaysNames.sort();
                    var lastDay = activeDaysNames[activeDaysNames.length-1];
                    var lastDayDate = new Date(lastDay);
                    //if(!this.isRealtime)
                    if(this.isStatistics)
                        this.mounted();
                    this.setSelectedDay( {day: lastDayDate.getDate(), month:lastDayDate.getMonth(), year:lastDayDate.getFullYear() }, true)
                    
                    this.getSelectedDayHours( lastDayDate)
                        .then(activeHours=>{
                            this.mounted();
                            var activeHourNames = activeHours.values;
                            if(activeHourNames.length > 0){
                                activeHourNames= activeHourNames.sort();
                                var lastHour = activeHourNames[activeHourNames.length-1];
                                //if(!this.isRealtime)
                                if(!this.isStatistics){
                                    
                                    this.setSelectedHour( lastHour.split('-')[3], true);
                                }else{
                                    this.setSelectedHour( '', true);                                    
                                }
                            }

                        })
                }
            })
    },
    watch: {
        selectedDayString: function(a,b){
            if(!this.getMounted) return;
            this.getSelectedDayHours(new Date(Date.UTC(this.getSelectedDay.year, this.getSelectedDay.month, this.getSelectedDay.day)));
        },
        isStatistics: function(stat){
            if(stat){
                this.setSelectedHour('');
                
            }
        }
    },
}
</script>

<style>
    .sidebar-downloading{
        margin-top: 40px;
    }
</style>



// WEBPACK FOOTER //
// CalendarContainer.vue?88a80a02